module.exports = __webpack_public_path__ + "static/media/faq-1.b4186b29.svg";